var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBpcLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 283.4917 128.16679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 428.95851,
    y1: 1952.42118,
    x2: 469.70645,
    y2: 1952.42118,
    gradientTransform: "translate(1063.55469 -1669.91649) rotate(44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28532,
    stopColor: "#228fc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57587,
    stopColor: "#3e71b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8244,
    stopColor: "#4f5ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5658a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 424.78648,
    y1: 1957.13472,
    x2: 474.32769,
    y2: 1957.13472,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 424.13357,
    y1: 1957.87825,
    x2: 474.87092,
    y2: 1957.87825,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 427.92213,
    y1: 1953.75336,
    x2: 471.0187,
    y2: 1953.75336,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 430.19209,
    y1: 1950.97067,
    x2: 468.03647,
    y2: 1950.97067,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 425.47599,
    y1: 1956.24827,
    x2: 473.69677,
    y2: 1956.24827,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 426.21061,
    y1: 1955.10691,
    x2: 472.96185,
    y2: 1955.10691,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 420.70827,
    y1: 1960.55611,
    x2: 477.22932,
    y2: 1960.55611,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 502.12814,
    y1: 1978.27279,
    x2: 432.19198,
    y2: 1978.27279,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 503.69607,
    y1: 1976.46195,
    x2: 430.87637,
    y2: 1976.46195,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 504.07264,
    y1: 1975.87781,
    x2: 430.50305,
    y2: 1975.87781,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 502.92795,
    y1: 1977.47517,
    x2: 431.56605,
    y2: 1977.47517,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 504.44596,
    y1: 1975.24496,
    x2: 430.10833,
    y2: 1975.24496,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 503.31527,
    y1: 1976.99478,
    x2: 431.22985,
    y2: 1976.99478,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 502.53202,
    y1: 1977.90061,
    x2: 431.88688,
    y2: 1977.90061,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    gradientTransform: "translate(222.88224 -583.58302) rotate(-33.87128) scale(.93384 .86439) skewX(21.62018)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49353,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54825,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61091,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67754,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74696,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81851,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89189,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96535,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 424.97434,
    y1: 1956.54545,
    x2: 473.03401,
    y2: 1956.54545,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ab",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ad",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ae",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "af",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ag",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ah",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ai",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aj",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 497.98286,
    y1: 1966.5685,
    x2: 437.3874,
    y2: 1966.5685,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "al",
    cx: -744.25659,
    cy: 516.20448,
    fx: -744.25659,
    fy: 516.20448,
    r: 44.00907,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: -1153.64277,
    y1: 846.28408,
    x2: -1098.71016,
    y2: 846.28408,
    gradientTransform: "translate(239.89988 -1338.10446) rotate(-45.50154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49353,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54825,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61091,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67754,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74696,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81851,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89189,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96535,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 498.98704,
    y1: 1966.16258,
    x2: 438.33299,
    y2: 1966.16258,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 4188.79631,
    y1: -1637.50052,
    x2: 4243.84632,
    y2: -1637.50052,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 4266.19684,
    y1: -1631.89401,
    x2: 4205.54279,
    y2: -1631.89401,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 4192.18411,
    y1: -1641.67003,
    x2: 4240.24386,
    y2: -1641.67003,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "as",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 4193.32009,
    y1: -1642.60204,
    x2: 4240.28057,
    y2: -1642.60204,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "au",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "av",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 4194.32891,
    y1: -1643.69563,
    x2: 4239.18354,
    y2: -1643.69563,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ax",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ay",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 4198.7247,
    y1: -1648.23722,
    x2: 4233.36012,
    y2: -1648.23722,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ba",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bb",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 4265.19264,
    y1: -1631.64699,
    x2: 4204.59721,
    y2: -1631.64699,
    gradientTransform: "translate(4225.45998 -1669.91649) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bd",
    cx: 2830.4107,
    cy: 4209.89958,
    fx: 2830.4107,
    fy: 4209.89958,
    r: 44.00907,
    gradientTransform: "translate(5542.85467 -583.58302) rotate(-146.12872) scale(.93384 -.86439) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 2477.07263,
    y1: 4581.90665,
    x2: 2532.00189,
    y2: 4581.90665,
    gradientTransform: "translate(5049.11478 -1338.10446) rotate(-134.49846) scale(1.00004 -1.00004)",
    xlinkHref: "#am"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.61824,44.51639c-.04836.17364-.09311.34714-.13409.52143.04082-.17418.08568-.34796.13409-.52143Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.54889,51.14251c.04343.16884.08954.3369.13989.50501-.05023-.16798-.0965-.33635-.13989-.50501Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.06387,52.72526c.05573.14212.10478.28481.16559.4262-.06069-.14126-.10982-.2841-.16559-.4262Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.28235,46.10627c-.02263.15354-.05167.30621-.06873.45994.01714-.15358.04602-.30655.06873-.45994Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.13013,43.00542c-.06275.15401-.1138.30907-.17073.46373.05686-.15461.10794-.3099.17073-.46373Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24569,49.61024c.02013.15339.05152.30582.07733.45891-.02572-.15294-.05724-.3057-.07733-.45891Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.13113,48.1188c-.00018-.00977-.00169-.01947-.00183-.02927.00014.0098.00165.0195.00183.02927Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.09974,59.13586c.3619.27443.73837.54354,1.13828.80274,3.64356,2.36167,8.2599,3.6697,12.98407,3.93198-1.58527-.67994-3.09373-1.47444-4.49454-2.38246-3.09075-2.00335-5.34866-4.35433-6.77376-6.86577.00119.00213.002.00432.00319.00645-1.36789,1.31068-2.288,2.8422-2.85724,4.50705Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.34142,76.89157c-.06071-.016-.12015-.03476-.18075-.05105-.24921-.06701-.4963-.138-.74313-.2098-.19829-.05759-.39624-.11584-.59316-.17668-.23893-.07383-.47621-.15046-.71275-.22887-.20293-.06726-.40473-.13614-.60579-.20678-.22666-.07968-.45223-.16095-.67633-.2449-.20843-.07803-.41498-.15903-.62108-.24076-.21244-.08434-.42441-.169-.63421-.25725-.21685-.09122-.43068-.18641-.64466-.2819-.19495-.08703-.39022-.17299-.5826-.26346-.22833-.10738-.45257-.22007-.67712-.33235-.17342-.08678-.34836-.17127-.51955-.26106-.25494-.13362-.50453-.27405-.75427-.41438-.13496-.0758-.27281-.14836-.40613-.22612-.38158-.22247-.7571-.45181-1.12459-.69-11.32709-7.34199-11.48809-19.35177-.35491-26.8245,1.57466-1.05701,3.29145-1.96525,5.10897-2.72736,1.6579-.69582,3.40168-1.2659,5.19886-1.71521,4.43009-1.10592,9.1912-1.46647,13.83885-1.07867l-.05702-4.30809-.06623-4.99855-.12538-9.48053c-11.26595-.06972-22.55951,2.76116-31.08041,8.48058-16.64371,11.17135-16.40412,29.12816.53271,40.10622,5.07336,3.28841,11.07102,5.57798,17.43049,6.87061-.31972-.07569-.63546-.16083-.95186-.24426.00067.00165.00123.00337.00206.00512Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39601,73.72234c-.13496-.0758-.27277-.14839-.40613-.22612.13332.07776.27117.15032.40613.22612Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.50583,76.0184c-.2267-.07965-.45223-.16095-.67633-.2449.22411.08395.44967.16522.67633.2449Z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.82437,76.45405c-.23897-.0738-.47621-.15046-.71275-.22887.23654.0784.47382.15504.71275.22887Z",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.92955,74.99359c-.19487-.08687-.39038-.17309-.5826-.26346.19238.09047.38765.17643.5826.26346Z",
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.16067,76.84052c-.24902-.06694-.4963-.138-.74313-.2098.24683.0718.49392.14279.74313.2098Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.20842,75.53274c-.21228-.08424-.42438-.16903-.63421-.25725.2098.08825.42177.17291.63421.25725Z",
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.66983,74.39777c-.1733-.08666-.34832-.1713-.51955-.26106.17119.08978.34612.17427.51955.26106Z",
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.13113,48.1188c.00632.49794.04919.99512.11457,1.49144-.06546-.49627-.10829-.99369-.11457-1.49144Z",
    style: {
      fill: "url(#s)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.48415,45.03781c-.08361.35518-.14886.71128-.2018,1.06846.05283-.3571.11835-.71339.2018-1.06846Z",
    style: {
      fill: "url(#t)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.32302,50.06915c.06057.359.1344.71673.22587,1.07336-.09143-.35645-.16522-.71441-.22587-1.07336Z",
    style: {
      fill: "url(#u)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22946,53.15145c.21276.49502.4495.9865.72434,1.4709-.27488-.48437-.51154-.97591-.72434-1.4709Z",
    style: {
      fill: "url(#v)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9594,43.46915c-.12783.3477-.2434.69629-.34116,1.04723.0978-.35076.21329-.69972.34116-1.04723Z",
    style: {
      fill: "url(#w)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.12929,48.08952c-.00529-.50811.02818-1.01617.08433-1.52331-.05623.50719-.08955,1.01515-.08433,1.52331Z",
    style: {
      fill: "url(#x)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.81821,41.53915c-.26287.4833-.48645.97323-.68808,1.46628.20159-.49301.42509-.9831.68808-1.46628Z",
    style: {
      fill: "url(#y)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.68878,51.64752c.10814.36145.23495.72025.37509,1.07774-.14002-.35736-.26703-.71645-.37509-1.07774Z",
    style: {
      fill: "url(#z)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.09974,59.13586c.56924-1.66486,1.48935-3.19637,2.85724-4.50705-.00119-.00213-.002-.00432-.00319-.00645-.27484-.4844-.51158-.97589-.72434-1.4709-.06081-.14139-.10986-.28408-.16559-.4262-.14014-.35749-.26695-.71629-.37509-1.07774-.05035-.16811-.09646-.33617-.13989-.50501-.09147-.35663-.1653-.71436-.22587-1.07336-.0258-.15309-.0572-.30552-.07733-.45891-.06538-.49633-.10825-.99351-.11457-1.49144-.00018-.00977-.00169-.01947-.00183-.02927-.00522-.50816.0281-1.01612.08433-1.52331.01706-.15374.0461-.3064.06873-.45994.05295-.35718.11819-.71328.2018-1.06846.04097-.17428.08573-.34778.13409-.52143.09776-.35095.21333-.69954.34116-1.04723.05693-.15466.10798-.30972.17073-.46373.20163-.49304.42521-.98297.68808-1.46628-1.79718.44931-3.54096,1.01939-5.19886,1.71521-4.26293,5.02156-3.42153,11.40661,2.4804,15.8815Z",
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.09974,59.13586c.56924-1.66486,1.48935-3.19637,2.85724-4.50705-.00119-.00213-.002-.00432-.00319-.00645-.27484-.4844-.51158-.97589-.72434-1.4709-.06081-.14139-.10986-.28408-.16559-.4262-.14014-.35749-.26695-.71629-.37509-1.07774-.05035-.16811-.09646-.33617-.13989-.50501-.09147-.35663-.1653-.71436-.22587-1.07336-.0258-.15309-.0572-.30552-.07733-.45891-.06538-.49633-.10825-.99351-.11457-1.49144-.00018-.00977-.00169-.01947-.00183-.02927-.00522-.50816.0281-1.01612.08433-1.52331.01706-.15374.0461-.3064.06873-.45994.05295-.35718.11819-.71328.2018-1.06846.04097-.17428.08573-.34778.13409-.52143.09776-.35095.21333-.69954.34116-1.04723.05693-.15466.10798-.30972.17073-.46373.20163-.49304.42521-.98297.68808-1.46628-1.79718.44931-3.54096,1.01939-5.19886,1.71521-4.26293,5.02156-3.42153,11.40661,2.4804,15.8815Z",
    style: {
      fill: "url(#ab)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.57421,75.27549c-.21681-.09125-.43068-.18641-.64466-.2819.21399.09549.42781.19068.64466.2819Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.57421,75.27549c-.21681-.09125-.43068-.18641-.64466-.2819.21399.09549.42781.19068.64466.2819Z",
    style: {
      fill: "url(#ac)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.34142,76.89157c-.00083-.00175-.00139-.00347-.00206-.00512-.05952-.01576-.11944-.02998-.17869-.04593.0606.01629.12004.03505.18075.05105Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.34142,76.89157c-.00083-.00175-.00139-.00347-.00206-.00512-.05952-.01576-.11944-.02998-.17869-.04593.0606.01629.12004.03505.18075.05105Z",
    style: {
      fill: "url(#ad)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34695,74.73013c-.22845-.1075-.45265-.22002-.67712-.33235.22454.11228.44879.22498.67712.33235Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34695,74.73013c-.22845-.1075-.45265-.22002-.67712-.33235.22454.11228.44879.22498.67712.33235Z",
    style: {
      fill: "url(#ae)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.15028,74.13672c-.25494-.13362-.50456-.27403-.75427-.41438.24974.14033.49933.28076.75427.41438Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.15028,74.13672c-.25494-.13362-.50456-.27403-.75427-.41438.24974.14033.49933.28076.75427.41438Z",
    style: {
      fill: "url(#af)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98988,73.49622c-.38154-.22249-.7571-.45181-1.12459-.69.36749.23819.74302.46753,1.12459.69Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98988,73.49622c-.38154-.22249-.7571-.45181-1.12459-.69.36749.23819.74302.46753,1.12459.69Z",
    style: {
      fill: "url(#ag)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11162,76.22518c-.20289-.06729-.40477-.13611-.60579-.20678.20106.07064.40286.13952.60579.20678Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11162,76.22518c-.20289-.06729-.40477-.13611-.60579-.20678.20106.07064.40286.13952.60579.20678Z",
    style: {
      fill: "url(#ah)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41753,76.63072c-.19825-.05762-.39627-.11581-.59316-.17668.19692.06084.39487.11908.59316.17668Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41753,76.63072c-.19825-.05762-.39627-.11581-.59316-.17668.19692.06084.39487.11908.59316.17668Z",
    style: {
      fill: "url(#ai)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8295,75.7735c-.20835-.07808-.41505-.15898-.62108-.24076.2061.08173.41265.16273.62108.24076Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8295,75.7735c-.20835-.07808-.41505-.15898-.62108-.24076.2061.08173.41265.16273.62108.24076Z",
    style: {
      fill: "url(#aj)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.61935,43.25436c-1.81752.76211-3.53431,1.67035-5.10897,2.72736-11.13318,7.47274-10.97218,19.48251.35491,26.8245.36749.23819.74306.46751,1.12459.69.13336.07773.27117.15032.40613.22612.24971.14035.49933.28076.75427.41438.17123.08976.34624.1744.51955.26106.22447.11233.44866.22485.67712.33235.19222.09037.38773.17659.5826.26346.21399.09549.42785.19065.64466.2819.20984.08823.42193.17301.63421.25725.20602.08178.41272.16267.62108.24076.22411.08395.44963.16525.67633.2449.20102.07067.4029.13949.60579.20678.23654.0784.47378.15507.71275.22887.19688.06087.39491.11906.59316.17668.24683.0718.49412.14286.74313.2098.05925.01594.11917.03017.17869.04593-2.14888-5.15521-4.14029-12.18744-2.24042-17.74836.00021-.00078.00059-.00145.0008-.00223-5.90192-4.4749-6.74333-10.85995-2.4804-15.8815Z",
    style: {
      fill: "url(#ak)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.61935,43.25436c-1.81752.76211-3.53431,1.67035-5.10897,2.72736-11.13318,7.47274-10.97218,19.48251.35491,26.8245.36749.23819.74306.46751,1.12459.69.13336.07773.27117.15032.40613.22612.24971.14035.49933.28076.75427.41438.17123.08976.34624.1744.51955.26106.22447.11233.44866.22485.67712.33235.19222.09037.38773.17659.5826.26346.21399.09549.42785.19065.64466.2819.20984.08823.42193.17301.63421.25725.20602.08178.41272.16267.62108.24076.22411.08395.44963.16525.67633.2449.20102.07067.4029.13949.60579.20678.23654.0784.47378.15507.71275.22887.19688.06087.39491.11906.59316.17668.24683.0718.49412.14286.74313.2098.05925.01594.11917.03017.17869.04593-2.14888-5.15521-4.14029-12.18744-2.24042-17.74836.00021-.00078.00059-.00145.0008-.00223-5.90192-4.4749-6.74333-10.85995-2.4804-15.8815Z",
    style: {
      fill: "url(#al)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.86447,77.88129c.09494.01199.19119.0176.28635.02923-.09469-.01153-.18934-.02308-.284-.03504-.00085.00185-.00166.00387-.00235.00582Z",
    style: {
      fill: "url(#am)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.09892,59.13807c.00022-.00077.00067-.00143.00089-.00223.3618.27443.73823.54356,1.13816.80274,3.64369,2.36169,8.25994,3.66971,12.98415,3.932-.16427-.00903-.32854-.02252-.49259-.03418-1.94998,4.58903-4.10304,9.77265-5.86281,14.03907-1.53986-.19433-3.06819-.43769-4.57546-.74476-.31968-.07571-.63558-.16085-.95194-.24427-2.14884-5.15522-4.14028-12.18746-2.2404-17.74838Z",
    style: {
      fill: "url(#an)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4804,87.72007c-.3618.27443-.73823.54356-1.13816.80274-3.64347,2.36169-7.76713,3.63553-12.49134,3.89782,1.5853-.67995,2.60109-1.44025,4.00172-2.34827,3.0908-2.00336,5.34871-4.35434,6.77373-6.8658-.00111.00216-.002.00435-.0031.00647,1.36783,1.31069,2.28806,2.84219,2.85714,4.50704Z",
    style: {
      fill: "url(#ao)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2389,105.4758c.06074-.01601.12016-.03477.18068-.05103.24918-.06701.49636-.138.7431-.2098.19841-.05761.39616-.11585.59324-.17668.23876-.07384.47619-.15047.71273-.22888.20285-.06726.40481-.13614.60566-.2068.22679-.07966.45225-.16092.67638-.24489.20861-.07801.415-.15902.62117-.24076.21238-.08434.42431-.169.63425-.25725.21681-.09121.43052-.1864.64467-.28189.19487-.08704.39017-.17298.5826-.26346.22834-.1074.45247-.22007.67704-.33237.17336-.08678.34827-.17127.51964-.26105.25494-.13361.50434-.27406.75419-.41437.13479-.07582.27268-.14838.40614-.22614.38153-.22245.75707-.4518,1.12441-.69,11.32724-7.34198,11.48819-19.35174.35515-26.82448-1.57488-1.05703-3.29165-1.96527-5.10906-2.72736-1.6578-.69581-3.40161-1.26591-5.19885-1.71523-4.43003-1.1059-9.19126-1.46646-13.83899-1.07867l.0572-4.3081.06606-4.99854.12548-9.48053c11.26583-.06971,22.5596,2.76118,31.08047,8.48057,16.64359,11.17137,16.40416,29.12816-.53272,40.10622-5.07337,3.28843-11.07097,5.57799-17.43058,6.87062.3199-.07571.63558-.16085.95194-.24427-.00067.00165-.00133.00336-.002.00512Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.34225,88.52281c.39993-.25918.77636-.52831,1.13816-.80274.00022.0008.00067.00146.00089.00223,1.89988,5.56096-.09156,12.59316-2.2404,17.74838-.31635.08342-.63204.16856-.95194.24427-1.50727.30711-3.0356.55043-4.57546.74476-1.75977-4.26642-3.91283-9.45004-5.86259-14.03907",
    style: {
      fill: "url(#ap)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4804,87.72007c-.56908-1.66485-1.48931-3.19634-2.85714-4.50704.00111-.00212.002-.00431.0031-.00647.2749-.48437.51166-.97587.72448-1.47088.06074-.1414.10974-.28408.1656-.42621.14011-.35748.26691-.71629.3751-1.07772.05032-.16812.09644-.33617.13966-.50503.09156-.35661.16538-.71435.22612-1.07337.02572-.15306.0572-.3055.07715-.45889.06562-.49629.10841-.99368.11461-1.49143.00022-.0098.00177-.01948.00177-.02928.00532-.50813-.02815-1.01619-.08424-1.5233-.01707-.15376-.04611-.30642-.06872-.45995-.05298-.35719-.11816-.71329-.20196-1.06847-.04079-.17426-.08557-.34776-.1339-.5214-.09777-.35098-.21327-.69954-.34118-1.04727-.05697-.15463-.10796-.30971-.1707-.46372-.20152-.493-.4252-.98311-.68813-1.46628,1.79724.44931,3.54105,1.01941,5.19885,1.71523,4.26287,5.02153,3.42156,11.40661-2.48049,15.88148Z",
    style: {
      fill: "url(#aq)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4804,87.72007c-.56908-1.66485-1.48931-3.19634-2.85714-4.50704.00111-.00212.002-.00431.0031-.00647.2749-.48437.51166-.97587.72448-1.47088.06074-.1414.10974-.28408.1656-.42621.14011-.35748.26691-.71629.3751-1.07772.05032-.16812.09644-.33617.13966-.50503.09156-.35661.16538-.71435.22612-1.07337.02572-.15306.0572-.3055.07715-.45889.06562-.49629.10841-.99368.11461-1.49143.00022-.0098.00177-.01948.00177-.02928.00532-.50813-.02815-1.01619-.08424-1.5233-.01707-.15376-.04611-.30642-.06872-.45995-.05298-.35719-.11816-.71329-.20196-1.06847-.04079-.17426-.08557-.34776-.1339-.5214-.09777-.35098-.21327-.69954-.34118-1.04727-.05697-.15463-.10796-.30971-.1707-.46372-.20152-.493-.4252-.98311-.68813-1.46628,1.79724.44931,3.54105,1.01941,5.19885,1.71523,4.26287,5.02153,3.42156,11.40661-2.48049,15.88148Z",
    style: {
      fill: "url(#ar)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4491,76.70304c-.00621.49775-.04899.99514-.11461,1.49143.0654-.49633.10818-.99349.11461-1.49143Z",
    style: {
      fill: "url(#as)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4491,76.70304c-.00621.49775-.04899.99514-.11461,1.49143.0654-.49633.10818-.99349.11461-1.49143Z",
    style: {
      fill: "url(#at)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4491,76.70304c-.00621.49775-.04899.99514-.11461,1.49143.0654-.49633.10818-.99349.11461-1.49143Z",
    style: {
      fill: "url(#au)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.36663,75.15045c.05609.50711.08956,1.01517.08424,1.5233.00532-.50817-.02815-1.01612-.08424-1.5233Z",
    style: {
      fill: "url(#av)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.36663,75.15045c.05609.50711.08956,1.01517.08424,1.5233.00532-.50817-.02815-1.01612-.08424-1.5233Z",
    style: {
      fill: "url(#aw)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.36663,75.15045c.05609.50711.08956,1.01517.08424,1.5233.00532-.50817-.02815-1.01612-.08424-1.5233Z",
    style: {
      fill: "url(#ax)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.76204,70.12337c.26292.48317.48661.97328.68813,1.46628-.20174-.49304-.4252-.98296-.68813-1.46628Z",
    style: {
      fill: "url(#ay)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.76204,70.12337c.26292.48317.48661.97328.68813,1.46628-.20174-.49304-.4252-.98296-.68813-1.46628Z",
    style: {
      fill: "url(#az)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.76204,70.12337c.26292.48317.48661.97328.68813,1.46628-.20174-.49304-.4252-.98296-.68813-1.46628Z",
    style: {
      fill: "url(#ba)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2389,105.4758c.00067-.00175.00133-.00347.002-.00512.05963-.01576.11949-.02998.17868-.04591-.06052.01627-.11993.03502-.18068.05103Z",
    style: {
      fill: "#00b4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2389,105.4758c.00067-.00175.00133-.00347.002-.00512.05963-.01576.11949-.02998.17868-.04591-.06052.01627-.11993.03502-.18068.05103Z",
    style: {
      fill: "url(#bb)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.96089,71.83859c1.81741.76209,3.53418,1.67033,5.10906,2.72736,11.13304,7.47275,10.97209,19.4825-.35515,26.82448-.36734.2382-.74288.46756-1.12441.69-.13346.07776-.27135.15032-.40614.22614-.24984.1403-.49925.28075-.75419.41437-.17137.08978-.34628.17426-.51964.26105-.22457.1123-.4487.22497-.67704.33237-.19243.09048-.38774.17642-.5826.26346-.21415.09549-.42786.19068-.64467.28189-.20994.08825-.42188.17291-.63425.25725-.20617.08174-.41256.16275-.62117.24076-.22413.08397-.44959.16523-.67638.24489-.20085.07066-.40281.13954-.60566.2068-.23654.07841-.47397.15504-.71273.22888-.19708.06083-.39483.11906-.59324.17668-.24674.0718-.49392.14279-.7431.2098-.05919.01594-.11905.03016-.17868.04591,2.14884-5.15522,4.14028-12.18742,2.2404-17.74838-.00022-.00077-.00067-.00143-.00089-.00223,5.90205-4.47487,6.74336-10.85995,2.48049-15.88148Z",
    style: {
      fill: "url(#bc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.96089,71.83859c1.81741.76209,3.53418,1.67033,5.10906,2.72736,11.13304,7.47275,10.97209,19.4825-.35515,26.82448-.36734.2382-.74288.46756-1.12441.69-.13346.07776-.27135.15032-.40614.22614-.24984.1403-.49925.28075-.75419.41437-.17137.08978-.34628.17426-.51964.26105-.22457.1123-.4487.22497-.67704.33237-.19243.09048-.38774.17642-.5826.26346-.21415.09549-.42786.19068-.64467.28189-.20994.08825-.42188.17291-.63425.25725-.20617.08174-.41256.16275-.62117.24076-.22413.08397-.44959.16523-.67638.24489-.20085.07066-.40281.13954-.60566.2068-.23654.07841-.47397.15504-.71273.22888-.19708.06083-.39483.11906-.59324.17668-.24674.0718-.49392.14279-.7431.2098-.05919.01594-.11905.03016-.17868.04591,2.14884-5.15522,4.14028-12.18742,2.2404-17.74838-.00022-.00077-.00067-.00143-.00089-.00223,5.90205-4.47487,6.74336-10.85995,2.48049-15.88148Z",
    style: {
      fill: "url(#bd)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.71572,106.46552c-.09488.01199-.1911.01758-.28642.02921.09488-.01152.18932-.02307.28421-.03502.00089.00183.00155.00387.00222.00581Z",
    style: {
      fill: "url(#be)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.83476.72264v121.53495c0,1.63213-.14121,3.33639,0,4.9642.00632.07289,0,.14901,0,.22235,0,.96272,1.49618.96431,1.49618,0V5.90919c0-1.63213.14121-3.33639,0-4.9642-.00632-.07289,0-.14901,0-.22235,0-.96272-1.49618-.96431-1.49618,0h0Z",
    style: {
      fill: "#2b3990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18018,89.66705l2.46387,6.5918,2.48828-6.5918h1.65137l-3.34961,8.37402h-1.66309l-3.31348-8.37402h1.72266Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.97412,98.04107v-.77734c-.44238.56201-1.16016.84912-2.06934.84912-1.37598,0-2.2373-.84912-2.2373-1.98584,0-1.18457.87402-1.91406,2.42871-1.92578h1.86621v-.16797c0-.74121-.49023-1.18408-1.44727-1.18408-.59863,0-1.24414.20361-1.90234.59814l-.5625-1.07666c.9209-.51416,1.63965-.78955,2.81152-.78955,1.6748,0,2.62012.84961,2.63184,2.27295l.01172,4.18701h-1.53125ZM131.9624,95.81597v-.57422h-1.61523c-.8252,0-1.20801.22705-1.20801.78955,0,.53809.43066.88525,1.13672.88525.89648,0,1.60254-.47852,1.68652-1.10059Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87158,89.16461v8.87646h-1.55469v-8.87646h1.55469Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.03174,94.83502c0,1.9502-1.36328,3.26562-3.36133,3.26562-2.02148,0-3.38574-1.31543-3.38574-3.26562,0-1.93799,1.36426-3.24219,3.38574-3.24219,1.99805,0,3.36133,1.3042,3.36133,3.24219ZM139.85205,94.85894c0,1.14844.74121,1.93799,1.81836,1.93799,1.05273,0,1.79395-.78955,1.79395-1.93799s-.74121-1.93799-1.79395-1.93799c-1.07715,0-1.81836.78955-1.81836,1.93799Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.11963,91.58111v1.50732c-1.35156-.0835-2.17676.70557-2.17676,1.86621v3.08643h-1.55566v-6.40039h1.55566v1.23242c.43066-.8374,1.18457-1.28027,2.17676-1.29199Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.94092,95.38531h-4.72559c.20312.90918.89746,1.45947,1.83008,1.45947.6582,0,1.26855-.25098,1.72266-.71777l.83789.87305c-.63379.69434-1.56738,1.10059-2.69141,1.10059-1.98633,0-3.29004-1.31543-3.29004-3.2417,0-1.94971,1.33984-3.26611,3.25391-3.26611,2.24902,0,3.21777,1.47168,3.0625,3.79248ZM155.52979,94.34478c-.03613-.94531-.66992-1.54346-1.63965-1.54346-.9209,0-1.56738.59814-1.70996,1.54346h3.34961Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.21045,92.78912c-.50195,0-.86133.16797-.86133.5625,0,1.07666,3.38574.51465,3.38574,2.81152,0,1.30371-1.16016,1.9375-2.52441,1.9375-.96875,0-1.97363-.31055-2.64355-.89697l.53809-1.08838c.58691.50195,1.47168.78906,2.16504.78906.53906,0,.94531-.1792.94531-.59766,0-1.18457-3.33789-.53857-3.3252-2.81152,0-1.31592,1.12402-1.92578,2.41602-1.92578.83789,0,1.71094.25098,2.34473.68164l-.5625,1.12451c-.62109-.37061-1.32715-.58643-1.87793-.58643Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82959,91.64068v8.72119h-1.55469v-3.34961c-.45508.70557-1.19629,1.10059-2.15332,1.10059-1.83008,0-3.05078-1.33984-3.05078-3.28955,0-1.93848,1.2207-3.24219,3.01465-3.24219.98145,0,1.72266.39453,2.18945,1.1123v-1.05273h1.55469ZM172.2749,94.85894c0-1.14844-.74219-1.94971-1.81836-1.94971-1.06543,0-1.80664.81348-1.81836,1.94971.01172,1.14844.74121,1.94971,1.81836,1.94971,1.07617,0,1.81836-.80127,1.81836-1.94971Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7417,91.64068v6.40039h-1.56738v-1.18457c-.44238.84961-1.20801,1.24414-2.22461,1.24414-1.43555,0-2.32129-.94482-2.32129-2.45215v-4.00781h1.56738v3.55322c0,.89697.51367,1.43555,1.375,1.43555,1.00586-.01221,1.60352-.80127,1.60352-1.83057v-3.1582h1.56738Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.41357,95.38531h-4.72559c.20312.90918.89746,1.45947,1.83008,1.45947.6582,0,1.26855-.25098,1.72266-.71777l.83789.87305c-.63379.69434-1.56738,1.10059-2.69141,1.10059-1.98633,0-3.29004-1.31543-3.29004-3.2417,0-1.94971,1.33984-3.26611,3.25391-3.26611,2.24902,0,3.21777,1.47168,3.0625,3.79248ZM188.00244,94.34478c-.03613-.94531-.66992-1.54346-1.63965-1.54346-.9209,0-1.56738.59814-1.70996,1.54346h3.34961Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.20947,91.64068v5.79004c0,1.83057-1.32715,2.99121-3.34961,2.99121-1.02832,0-1.94922-.33496-2.70312-.84961l.62207-1.12451c.58594.43066,1.23242.66992,1.99805.66992,1.14844,0,1.87793-.63428,1.87793-1.65088v-.75391c-.43066.64648-1.125,1.00488-2.0332,1.00488-1.69922,0-2.84766-1.24414-2.84766-3.08594,0-1.80664,1.13672-3.03906,2.79883-3.03906.92188-.01172,1.63965.35938,2.08203,1.00488v-.95703h1.55469ZM198.65479,94.66754c0-1.07666-.69336-1.83057-1.69922-1.83057-1.00391,0-1.69824.76562-1.70996,1.83057.01172,1.07666.69336,1.83057,1.70996,1.83057,1.00586,0,1.69922-.75391,1.69922-1.83057Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.7749,95.38531h-4.72559c.20312.90918.89746,1.45947,1.83008,1.45947.6582,0,1.26855-.25098,1.72266-.71777l.83789.87305c-.63379.69434-1.56738,1.10059-2.69141,1.10059-1.98633,0-3.29004-1.31543-3.29004-3.2417,0-1.94971,1.33984-3.26611,3.25391-3.26611,2.24902,0,3.21777,1.47168,3.0625,3.79248ZM206.36377,94.34478c-.03613-.94531-.66992-1.54346-1.63965-1.54346-.9209,0-1.56738.59814-1.70996,1.54346h3.34961Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86279,91.58111v1.50732c-1.35156-.0835-2.17676.70557-2.17676,1.86621v3.08643h-1.55566v-6.40039h1.55566v1.23242c.43066-.8374,1.18359-1.28027,2.17676-1.29199Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.50635,98.04107v-.77734c-.44238.56201-1.16016.84912-2.06934.84912-1.37598,0-2.2373-.84912-2.2373-1.98584,0-1.18457.87305-1.91406,2.42871-1.92578h1.86621v-.16797c0-.74121-.49023-1.18408-1.44727-1.18408-.59863,0-1.24414.20361-1.90234.59814l-.5625-1.07666c.92188-.51416,1.63867-.78955,2.81152-.78955,1.6748,0,2.62012.84961,2.63184,2.27295l.01172,4.18701h-1.53125ZM217.49463,95.81597v-.57422h-1.61523c-.8252,0-1.20801.22705-1.20801.78955,0,.53809.43066.88525,1.13672.88525.89746,0,1.60254-.47852,1.68652-1.10059Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.50732,94.04547v3.99561h-1.56738v-3.54102c0-.90918-.53809-1.45947-1.39941-1.45947-1.00488.03564-1.61426.80127-1.61426,1.84229v3.1582h-1.56738v-3.54102c0-.90918-.52637-1.45947-1.3877-1.45947-1.01758.03564-1.62695.80127-1.62695,1.84229v3.1582h-1.55566v-6.40039h1.55566v1.18457c.44238-.84961,1.23242-1.23242,2.24902-1.24414,1.12402,0,1.90137.5625,2.20117,1.53125.41895-1.04102,1.25586-1.51953,2.37988-1.53125,1.44824,0,2.33301.94531,2.33301,2.46436Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.06006,94.04547v3.99561h-1.56738v-3.54102c0-.89746-.53809-1.44727-1.42285-1.44727-1.05273.01172-1.6748.78906-1.6748,1.8418v3.14648h-1.55566v-6.40039h1.55566v1.19629c.4541-.84912,1.25586-1.24414,2.29688-1.25586,1.4707,0,2.36816.94531,2.36816,2.46436Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54053,95.38531h-4.72559c.20312.90918.89746,1.45947,1.83008,1.45947.6582,0,1.26855-.25098,1.72266-.71777l.83789.87305c-.63379.69434-1.56738,1.10059-2.69141,1.10059-1.98633,0-3.29004-1.31543-3.29004-3.2417,0-1.94971,1.33984-3.26611,3.25391-3.26611,2.24902,0,3.21777,1.47168,3.0625,3.79248ZM249.12939,94.34478c-.03613-.94531-.66992-1.54346-1.63965-1.54346-.9209,0-1.56738.59814-1.70996,1.54346h3.34961Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74658,91.64068v5.79004c0,1.83057-1.32812,2.99121-3.34961,2.99121-1.0293,0-1.9502-.33496-2.7041-.84961l.62207-1.12451c.58594.43066,1.23242.66992,1.99805.66992,1.14844,0,1.87793-.63428,1.87793-1.65088v-.75391c-.43066.64648-1.12402,1.00488-2.03418,1.00488-1.69824,0-2.84668-1.24414-2.84668-3.08594,0-1.80664,1.13672-3.03906,2.7998-3.03906.9209-.01172,1.63867.35938,2.08105,1.00488v-.95703h1.55566ZM256.19092,94.66754c0-1.07666-.69434-1.83057-1.69824-1.83057-1.00586,0-1.69922.76562-1.71094,1.83057.01172,1.07666.69336,1.83057,1.71094,1.83057,1.00391,0,1.69824-.75391,1.69824-1.83057Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.7417,94.83502c0,1.9502-1.36426,3.26562-3.36133,3.26562-2.02246,0-3.38574-1.31543-3.38574-3.26562,0-1.93799,1.36328-3.24219,3.38574-3.24219,1.99707,0,3.36133,1.3042,3.36133,3.24219ZM260.56201,94.85894c0,1.14844.74121,1.93799,1.81836,1.93799,1.05273,0,1.79395-.78955,1.79395-1.93799s-.74121-1.93799-1.79395-1.93799c-1.07715,0-1.81836.78955-1.81836,1.93799ZM264.30615,89.57134l-1.4834,1.23242h-1.31641l1.26855-1.84277,1.53125.61035Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.82471,92.95709c-1.02832,0-1.74609.76562-1.74609,1.88965,0,1.14844.71777,1.91406,1.74609,1.91406.74219,0,1.33984-.25098,1.72266-.75342l.96875.80127c-.56152.81348-1.51855,1.29199-2.77539,1.29199-1.91406,0-3.22949-1.31543-3.22949-3.2417,0-1.94971,1.32812-3.26611,3.25391-3.26611,1.17285,0,2.10547.43066,2.67969,1.17285l-.94531.89697c-.40625-.44287-.96875-.70557-1.6748-.70557Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.46338,89.8106c0,.50244-.34668.86133-.83789.86133-.49023,0-.83691-.35889-.83691-.86133s.34668-.86133.83691-.86133c.49121,0,.83789.35889.83789.86133ZM275.40381,91.64068v6.40039h-1.55566v-6.40039h1.55566Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.4917,94.83502c0,1.9502-1.36426,3.26562-3.36133,3.26562-2.02246,0-3.38574-1.31543-3.38574-3.26562,0-1.93799,1.36328-3.24219,3.38574-3.24219,1.99707,0,3.36133,1.3042,3.36133,3.24219ZM278.31201,94.85894c0,1.14844.74121,1.93799,1.81836,1.93799,1.05273,0,1.79395-.78955,1.79395-1.93799s-.74121-1.93799-1.79395-1.93799c-1.07715,0-1.81836.78955-1.81836,1.93799Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61461,43.09484v-.2813c0-3.96138.87085-6.97779,2.58814-8.96627,1.68612-1.95353,4.3947-2.94398,8.05077-2.94398.68136,0,1.20606.02021,1.55811.05938l.95845.10738v-4.79981l-.78074-.07454c-.45985-.0438-1.12942-.06611-1.98932-.06611-4.96067,0-8.87783,1.44525-11.64368,4.29658-2.7549,2.8467-4.15214,7.01442-4.15214,12.38736v.2813h-5.84332v4.58462h5.84332v28.91212h0c2.98809,0,5.41041-2.42232,5.41041-5.41041v-23.50171h13.15546v-.5206c0-.00479.00084-.00953.00084-.01432v-4.04971h-13.15631Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.843,58.92772c-3.03704,0-5.5317.61608-7.41237,1.83141-1.78635,1.15342-2.65467,2.82901-2.65467,5.12238,0,2.29799.85991,3.98496,2.62941,5.15733,1.85962,1.23301,4.21194,1.85836,6.9921,1.85836,1.97164,0,3.78746-.40806,5.39694-1.21237,1.55137-.77358,3.12126-2.00532,4.67095-3.66365v-6.53773c-1.55895-.88728-3.0741-1.532-4.51008-1.91942-1.56653-.42195-3.28718-.6363-5.11227-.6363Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2336,58.92772c-3.03704,0-5.5317.61608-7.41237,1.83141-1.78635,1.15384-2.65467,2.82944-2.65467,5.12238,0,2.29799.86075,3.98496,2.63025,5.15691,1.85878,1.23343,4.2111,1.85878,6.9921,1.85878,1.97164,0,3.78746-.40806,5.3961-1.21237,1.55137-.77274,3.12126-2.00448,4.67095-3.66365v-6.53773c-1.55895-.88728-3.0741-1.532-4.51008-1.91942-1.56653-.42195-3.28718-.6363-5.11227-.6363Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.36336,52.63886h-.00084c-2.64794-.88012-5.97218-1.67054-9.88428-2.34979-2.43907-.41395-4.53451-.90623-6.22821-1.46336-1.60232-.52765-2.96461-1.33492-4.04981-2.3999-1.02245-1.00477-1.51978-2.31063-1.51978-3.99296,0-2.57382,1.169-4.50124,3.57396-5.89343,2.52455-1.46251,5.6715-2.20409,9.35326-2.20409,2.46644,0,4.84866.26025,7.08138.774,2.2083.50575,4.16309,1.27217,5.81131,2.27778l.64261.39205,3.32171-4.07929-.83717-.51586c-2.06344-1.27217-4.47724-2.24788-7.17487-2.89934-2.68163-.65019-5.55149-.9795-8.52915-.9795-3.1739,0-6.18736.48722-8.95616,1.44777-2.81807.97529-5.14175,2.47865-6.90535,4.46755-1.81119,2.03817-2.72963,4.57199-2.72963,7.5307,0,2.78943.77905,5.07774,2.31568,6.80134,1.49073,1.66886,3.37056,2.93387,5.5856,3.75967,2.13124.79842,4.75727,1.48567,7.81748,2.04491,3.51163.58661,6.40129,1.2288,8.58937,1.90973,2.11144.65735,3.84389,1.58085,5.14764,2.74437,1.21785,1.08815,1.80909,2.48876,1.80909,4.281,0,2.77764-1.22543,4.79517-3.74619,6.16883-2.65636,1.4482-5.9806,2.18261-9.88007,2.18261-3.15495,0-6.22021-.46743-9.11113-1.38924-2.83702-.90496-5.05837-2.16703-6.60216-3.75167l-.65061-.66788-3.43625,3.91421.57145.57145c1.95269,1.95269,4.7198,3.51963,8.22427,4.65705,3.46447,1.1252,7.10243,1.69581,10.81325,1.69581,3.2935,0,6.3975-.46322,9.22483-1.37703,2.8846-.93276,5.27566-2.41296,7.1058-4.39933,1.87983-2.04028,2.83238-4.62041,2.83238-7.66967,0-3.10147-.93907-5.62434-2.79027-7.49912-1.78298-1.80488-4.06708-3.18064-6.78913-4.0894Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.50298,43.77493c-2.22262-.99887-4.7358-1.50547-7.47133-1.50547-2.14261,0-4.34417.29857-6.5432.88686-2.19903.58745-4.16225,1.37577-5.83489,2.34221l-.65525.37858,1.74424,4.20015.84559-.47333c3.41183-1.90889,6.77565-2.8766,9.99883-2.8766,2.87955,0,5.28493.75926,7.15044,2.25757,1.8352,1.47094,2.72795,3.38109,2.72795,5.83995v2.1405c-1.59011-.70452-3.10779-1.23469-4.52609-1.58085-1.79982-.4388-3.68555-.66114-5.60581-.66114-4.22457,0-7.75515.94834-10.49405,2.81849-2.84333,1.94342-4.28521,4.81286-4.28521,8.52831,0,2.51613.69315,4.67347,2.05923,6.41224,1.33913,1.70297,3.09937,2.98103,5.23102,3.79841,2.0786.79716,4.3627,1.201,6.78997,1.201,2.40369,0,4.62126-.46533,6.59121-1.38334,1.47725-.68683,2.96714-1.69412,4.44523-3.0042h0c.08048,1.95436,1.68828,3.49732,3.6443,3.49732h1.56062v-21.70441c0-2.5355-.67125-4.7956-1.99606-6.71796-1.31723-1.90384-3.12632-3.38235-5.37673-4.39428ZM185.46535,68.02116c-1.54968,1.65833-3.11958,2.89008-4.67095,3.66365-1.60948.80432-3.42531,1.21237-5.39694,1.21237-2.78017,0-5.13248-.62535-6.9921-1.85836-1.7695-1.17237-2.62941-2.85933-2.62941-5.15733,0-2.29336.86833-3.96896,2.65467-5.12238,1.88068-1.21532,4.37533-1.83141,7.41237-1.83141,1.82509,0,3.54574.21434,5.11227.6363,1.43598.38742,2.95114,1.03214,4.51008,1.91942v6.53773Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07594,43.43973l-.00084.00042c-1.27428.75842-2.9663,2.09755-5.14764,4.07381l-.15328-4.41912h-5.06511v33.49674h5.41042v-23.75311c2.52918-2.43443,4.44692-4.07634,5.70182-4.88108,1.23132-.78621,2.53508-1.16816,3.98538-1.16816.33099,0,.78242.04001,1.3425.11833l.98203.13812v-5.03015h-1.62633c-2.01122,0-3.83715.47922-5.42894,1.42419Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.27115,48.17047l-.00084-.00126c-1.31723-1.90384-3.12632-3.38235-5.37673-4.39428-2.22177-.99887-4.73496-1.50547-7.47048-1.50547-2.14345,0-4.34501.29857-6.54404.88686-2.19903.58787-4.16225,1.37577-5.83405,2.34221l-.65525.37858,1.74255,4.20015.84643-.47333c3.41267-1.90889,6.7765-2.8766,9.99883-2.8766,2.88039,0,5.28577.75926,7.15044,2.25757,1.8352,1.47094,2.72795,3.38109,2.72795,5.83995v2.1405c-1.58843-.7041-3.1061-1.23469-4.52609-1.58085-1.79982-.4388-3.68555-.66114-5.60581-.66114-4.22373,0-7.75431.94834-10.49405,2.81849-2.84249,1.943-4.28437,4.81244-4.28437,8.52831,0,2.51613.69315,4.67347,2.05923,6.41181,1.33829,1.70297,3.09768,2.98103,5.23018,3.79883,2.07944.79716,4.36354,1.201,6.78997,1.201,2.40369,0,4.62126-.46533,6.59121-1.38334,1.47725-.68683,2.96714-1.69412,4.44607-3.00462h0c.08048,1.9546,1.68847,3.49774,3.64472,3.49774h1.55936v-21.70441c0-2.5355-.67125-4.7956-1.99522-6.7167ZM277.85595,68.02116c-1.54968,1.65917-3.11958,2.89092-4.67095,3.66365-1.60864.80432-3.42446,1.21237-5.3961,1.21237-2.78101,0-5.13333-.62535-6.9921-1.85878-1.7695-1.17195-2.63025-2.85891-2.63025-5.15691,0-2.29294.86833-3.96854,2.65467-5.12238,1.88068-1.21532,4.37533-1.83141,7.41237-1.83141,1.82509,0,3.54574.21434,5.11227.6363,1.43598.38742,2.95114,1.03214,4.51008,1.91942v6.53773Z",
    style: {
      fill: "#21409a"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.1106,
    y1: 48.41649,
    x2: 221.11144,
    y2: 48.33239,
    style: {
      fill: "#2b3990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.99999,42.94038c-2.69479,0-4.8794,2.18014-4.88856,4.87266v28.77854h5.47527v-33.6512h-.58671Z",
    style: {
      fill: "#2b3990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58713,38.09195h-.58671c-2.5974,0-4.71569,2.0268-4.87403,4.58436h5.46074v-4.58436Z",
    style: {
      fill: "#2b3990"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpcLogo);
export default __webpack_public_path__ + "static/media/BPC_logo.084067c153919e448945374003e35a5f.svg";
export { ForwardRef as ReactComponent };